import { render, staticRenderFns } from "./IndemnityData.vue?vue&type=template&id=7a9c458e"
import script from "./IndemnityData.vue?vue&type=script&lang=js"
export * from "./IndemnityData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports